// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1jESj","inputWrap":"Table_inputWrap__1Cr48","col":"Table_col__3eoUF","bmiTooltip":"Table_bmiTooltip__3bBFc"};